module.exports = __webpack_public_path__ + "img/img-10.d6b9510b.png";